import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
// Constants - Functions
import { graphicDataColor1, graphicDataColor2 } from "../../../../../config/constants";
import { levelsByProtocol } from "../../../functions";
// Components
import PlotWithLevels from "../plotWithLevels";

const HitsAndErrorsPlot = ({ sessions }) => {
  const [currentLevel, setCurrentLevel] = useState("total");
  const [levels] = useState(new Array(levelsByProtocol).fill(0).map((_, i) => i));
  const [positions, setPositions] = useState([]);
  const [hitsValues, setHitsValues] = useState([]);
  const [errorsValues, setErrorsValues] = useState([]);
  const [t] = useTranslation("global");

  useEffect(() => {
    let positions = [];
    let hitsValues = [];
    let errorsValues = [];

    sessions.forEach((session, i) => {
      positions.push(i + 1);

      let totalHits = "-";
      let totalErrors = "-";

      let targetedLevels = isNaN(currentLevel) ? levels : [currentLevel];

      for (const level of targetedLevels) {
        const hits = session.hasOwnProperty(`totalHits_level${level}`)
          ? Number(session[`totalHits_level${level}`])
          : session.hasOwnProperty(`totalErrors_level${level}`)
          ? 0
          : "-";

        const errors = session.hasOwnProperty(`totalErrors_level${level}`)
          ? Number(session[`totalErrors_level${level}`])
          : session.hasOwnProperty(`totalHits_level${level}`)
          ? 0
          : "-";

        if (!isNaN(hits) && !isNaN(errors)) {
          totalHits = isNaN(totalHits) ? hits : hits + totalHits;
          totalErrors = isNaN(totalErrors) ? errors : errors + totalErrors;
        }
      }

      const hits = isNaN(totalHits) ? NaN : totalHits;
      const errors = isNaN(totalErrors) ? NaN : totalErrors;
      hitsValues.push(hits);
      errorsValues.push(errors);
    });

    setPositions(positions);
    setHitsValues(hitsValues);
    setErrorsValues(errorsValues);

    return () => {
      setPositions([]);
      setHitsValues([]);
      setErrorsValues([]);
    };
  }, [sessions, currentLevel, levels]);

  const Data = {
    labels: positions,
    datasets: [
      {
        data: hitsValues,
        backgroundColor: [graphicDataColor1],
        borderColor: [graphicDataColor1],
      },
      {
        data: errorsValues,
        backgroundColor: [graphicDataColor2],
        borderColor: [graphicDataColor2],
      },
    ],
  };

  return (
    <PlotWithLevels
      title={t("hitsAndErrors")}
      data={Data}
      axisY={t("hitsAndErrors")}
      axisX={t("sessions")}
      showLegend={false}
      currentLevel={currentLevel}
      setCurrentLevel={setCurrentLevel}
    />
  );
};

export default HitsAndErrorsPlot;
